import React from 'react';

const HeroSection = () => {
  // Background image path - easily customizable
  const backgroundImage = '/images/hero-background.jpg';

  return (
    <section 
      className="relative py-20 bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `url(${backgroundImage})`
      }}
    >
      {/* Blue gradient overlay for text readability */}
      <div className="absolute inset-0 bg-gradient-to-br from-catalina-blue/55 to-san-marino/55"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h1 className="text-5xl font-bold text-white mb-4">About Us</h1>
        <p className="text-xl text-white/90">Your Trusted Partner in Premium Material Handling Equipment</p>
      </div>
    </section>
  );
};

export default HeroSection;